// extracted by mini-css-extract-plugin
export default {"activate_plugin_btn":"ActivatePluginButton_activate_plugin_btn__tlrLQ"};